import { UserProfileGateway } from '../user-management/gateways/user-profile-gateway'
import { FieldValidator } from './field-validator'

export class PasswordCorrectValidator implements FieldValidator<string> {
    isOldPasswordCorrect: boolean

    constructor(private userProfileGateway: UserProfileGateway, private userProfileID: number) {}

    validate(text: string, fieldName: string): Promise<string> {
        const oldPasswordErrorMsg = `The password you entered is incorrect`

        this.isOldPasswordCorrect = this.userProfileGateway.isPasswordCorrect(encodeURIComponent(text), this.userProfileID)

        return new Promise((resolve, reject) => {
            if (!this.isOldPasswordCorrect) {
                reject(oldPasswordErrorMsg)
            } else {
                resolve('')
            }
        })
    }
}
